<template>
	<div class="question">
		<div ref="question" class="question__category-header">
			<div class="question__category-number">
				{{ categoryIndex + 1 }}
			</div>
			<h3 class="question__category-title">
				{{ category.name[locale] }}
			</h3>
		</div>
		<h4>{{ $t("question") }} {{ number }}/{{ total }}</h4>
		<h3>{{ question.question[locale] }}</h3>
		<ul class="question__answers">
			<li v-for="answer in question.answers" :key="answer.id" @click="changeSelectedKey(answer.id)">
				<v-checkbox
					ref="checkbox"
					color="primary"
					:input-value="selected || []"
					:value="answer.id"
					:label="answer.answer[locale]"
					hide-details
					class="question__answer"
				/>
			</li>
			<li>
				<div class="question__divider">
					{{ $t("or") }}
				</div>
			</li>
			<li @click="changeSelectedUnknown">
				<v-checkbox
					:input-value="selected !== undefined && selected.length === 0"
					:label="$t('dontKnow')"
					color="primary"
					hide-details
					off-icon="radio_button_unchecked"
					on-icon="radio_button_checked"
					class="question__answer question__radio"
				/>
			</li>
			<li v-if="enableNotApplicable" @click="changeSelectedNotApplicable">
				<v-checkbox
					:input-value="selected !== undefined && selected.includes(null)"
					:label="$t('notApplicable')"
					color="primary"
					hide-details
					off-icon="radio_button_unchecked"
					on-icon="radio_button_checked"
					class="question__answer question__radio"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	model: {
		prop: "selected",
		event: "input",
	},
	props: {
		question: {
			type: Object,
			required: true,
		},
		category: {
			type: Object,
			required: true,
		},
		categoryIndex: {
			type: Number,
			required: true,
		},
		number: {
			type: Number,
			required: true,
		},
		total: {
			type: Number,
			required: true,
		},
		selected: {
			required: true,
			validator(val) {
				if (Array.isArray(val) || val === undefined || (Array.isArray(val) && val.includes(null))) {
					return true;
				}
				return false;
			},
		},
	},
	computed: {
		locale() {
			return this.$i18n.locale;
		},
		...mapGetters(['enableNotApplicable']),
	},
	methods: {
		changeSelectedKey(key) {
			const val = this.selected ? this.selected.filter((s) => s !== null) : [];
			console.log(val);
			const index = val.indexOf(key);
			if (index < 0) {
				val.push(key);
			} else {
				val.splice(index, 1);
			}
			this.$emit("input", val);
		},
		changeSelectedUnknown() {
			if (this.selected && this.selected.length === 0) this.$emit("input", undefined);
			else {
				this.$emit("input", []);
			}
		},
		changeSelectedNotApplicable() {
			if (this.selected && this.selected.includes(null)) this.$emit("input", undefined);
			else {
				this.$emit("input", [null]);
			}
		},
		focusFirstAnswer() {
			this.$nextTick(() => this.$refs.checkbox[0].$el.getElementsByTagName("input")[0].focus());
		},
		scrollToTop() {
			this.$nextTick(() => {
				if (this.$refs.question) {
					if (this.$refs.question.getBoundingClientRect().top < 0) {
						this.$refs.question.scrollIntoView(true);
					}
				}
			});
		},
	},
	i18n: {
		messages: {
			en: {
				or: "or",
				dontKnow: "I don't know",
				notApplicable: "Not applicable",
				question: "Question",
			},
			nl: {
				or: "of",
				dontKnow: "Ik weet het niet",
				notApplicable: "Niet van toepassing",
				question: "Vraag",
			},
		},
	},
};
</script>

<style lang="scss">
.question {
	min-height: 400px;
}
.question__answers {
	padding: 0;
	margin: 0;
	list-style-type: none;
}
.question__answer {
	cursor: pointer;
	min-height: 54px;
	margin: 12px 0;
	border-radius: 5px;
	padding: 15px 18px;
	border: 1px solid transparent;

	/* IE11 Shadow fix */
	box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.25);
	@supports (display: block) {
		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
	}
}
.question__answer.v-input--is-label-active {
	box-shadow: none;
	border: solid 1px var(--primary-color);
}
.question__checkbox {
	width: 52px;
	text-align: center;
}

.question__answer.v-input--selection-controls {
	margin-top: 12px;
	padding-top: 15px;
}

.question__answer .v-input--selection-controls__input {
	padding-top: 4px;
	align-self: start;
}
.question__answer.v-input--selection-controls .v-input__control {
	width: 100%;
}
.question__answer .v-input--selection-controls__input .v-icon {
	color: var(black);
}
.question__answer label.v-label {
	user-select: auto;
	padding: 3px 0;
	font-size: 15px;
	color: black !important;
}
.question__answer.v-input--is-label-active label.v-label {
	color: var(--primary-color) !important;
}
.question__answer .v-input--selection-controls__ripple {
	top: calc(50% - 20px);
}

.question__divider {
	margin: 25px 0;
	text-align: center;
	color: #808080;
}

.question__category-header {
	display: none;
	align-items: center;
	margin-bottom: 20px;
}

.question__category-number {
	width: 34px;
	height: 34px;
	background-color: var(--primary-color);
	border-radius: 50%;
	flex-shrink: 0;
	font-size: 16px;

	display: inline-flex;
	justify-content: center;
	align-items: center;
	color: $white;
}

.question__category-title {
	color: var(--primary-color);
	margin: 0 0 0 10px;
	font-size: 18px;
}

@media only screen and (max-width: $mobile-breakpoint) {
	.question__category-header {
		display: flex;
	}
}
</style>
